import { useEffect } from 'react';
import { usePoiStore } from '../../../../../features/shop-dine-relax/search/domain/hooks/usePoiStore';
import { useCreateUnifiedSearchFlightStore } from './useCreateUnifiedSearchFlightStore';
import { useCreateUnifiedSearchInformationStore } from './useCreateUnifiedSearchInformationStore';

export function useCreateUnifiedSearchStores(query: string) {
	const flightStore = useCreateUnifiedSearchFlightStore();
	const locationStore = usePoiStore();
	const informationStore = useCreateUnifiedSearchInformationStore();

	useEffect(() => {
		if (query !== '' && informationStore.userQuery !== query) {
			flightStore.setQuery(query);
			locationStore.setSearchQuery(query);
			informationStore.setUserQuery(query);
		}
	}, [flightStore, locationStore, informationStore, query]);

	return { flightStore, locationStore, informationStore };
}
